import {DEFAULT_RENDERER} from '../defaults';
import {get} from '@servicenow/ui-internal';

export default function resolveRenderer(config = {}) {
	const type = get(config, 'renderer.type', config.type || DEFAULT_RENDERER.type);
	const coeffects = get(config, 'renderer.coeffects', null);
	const transformProps = get(
		config,
		'renderer.transformProps',
		config.transformProps || DEFAULT_RENDERER.transformState
	);
	const transformState = get(
		config,
		'renderer.transformState',
		config.transformState || transformProps
	);
	const view = get(config, 'renderer.view', config.view || DEFAULT_RENDERER.view);

	return {
		type,
		transformState,
		view,
		coeffects
	};
}
